import { useAccordionButton } from "react-bootstrap";
import PropTypes from "prop-types";
import Image from "next/image";
import classNames from "classnames";
import { IMAGE_BASE_PATH } from "@/config/config";

const CustomToggle = ({ eventKey, children, activeKeys, setActiveKeys }) => {
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    if (typeof setActiveKeys !== "function") return;

    setActiveKeys((prev) =>
      prev?.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...(prev || []), eventKey]
    );
  });

  const isActive = activeKeys?.includes(eventKey);

  return (
    <div
      className="d-flex justify-content-between w-100 align-items-center accordion-header-wrapper"
      onClick={decoratedOnClick}
      style={{ cursor: "pointer" }}
    >
      <span>{children ?? ""}</span>
      <Image
        src={`${IMAGE_BASE_PATH}/images/arrow-dropdown.svg`}
        alt="Dropdown"
        width={30}
        height={30}
        className={classNames("accordion-arrow", {
          rotated: isActive,
        })}
      />
    </div>
  );
};

CustomToggle.propTypes = {
  eventKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  activeKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  setActiveKeys: PropTypes.func.isRequired,
};

export default CustomToggle;
